import React from "react"
import ReactTooltip from "react-tooltip"
class tooltips extends React.Component {
    
    componentDidMount() {
        setInterval(() => {
            ReactTooltip.rebuild();
          }, 1000);
    }
    render() {
        return (
            <ReactTooltip className="c-tooltip" html={true} />
        )
    }
}

export default tooltips